import type { PaymentLimitsTranslations } from "../interfaces/paymentLimits";

export const paymentLimitsTranslations: PaymentLimitsTranslations = {
  // Page
  page_title: "Limites de valor",
  page_subtitle:
    "Mínimo e máximo por operação, por trilho e tipo de pagador, global ou por organização, sem implantações",
  refresh_button: "Atualizar",
  refresh_aria: "Atualizar os limites",
  why_banner:
    "Um valor fora da faixa é rejeitado na prévia e na criação da operação. O que já está em andamento não é afetado: liquida normalmente.",

  // Scope selector
  scope_label: "Escopo",
  scope_placeholder: "Buscar por nome, e-mail ou ID…",
  scope_loading: "Carregando organizações…",
  scope_empty: "Nenhuma organização encontrada.",
  scope_searching: "Buscando organizações…",
  scope_search_error: "Não foi possível concluir a busca; mostrando as organizações já carregadas.",
  scope_global_option: "Global (todas as organizações)",
  scope_global_label: "Global",
  scope_global_hint: "Escopo global: os limites que qualquer organização sem override próprio herda.",
  scope_org_hint:
    "As alterações aqui criam um override para esta organização, que prevalece sobre os limites globais.",
  scope_catalog_error:
    "Não foi possível carregar o catálogo de organizações; os overrides podem mostrar IDs em vez de nomes.",
  scope_catalog_truncated:
    "Há mais organizações do que as listadas; digite para buscar todas. Alguns overrides podem mostrar o ID.",

  // KPI strip
  kpi_all: "Corredores",
  kpi_limited: "Com limite",
  kpi_overrides: "Com overrides",
  kpi_own_overrides: "Com override próprio",

  // Table / cards
  section_payins: "Recebimentos (payins)",
  section_payouts: "Pagamentos (payouts)",
  th_rail: "Trilho",
  th_country: "País",
  th_currency: "Moeda",
  th_person: "Pessoa física",
  th_company: "Empresa",
  th_source: "Origem",
  th_overrides: "Overrides",
  direction_payin: "Recebimentos",
  direction_payout: "Pagamentos",
  country_ar: "Argentina",
  country_br: "Brasil",
  country_co: "Colômbia",
  country_mx: "México",
  bound_min: "Mín.",
  bound_max: "Máx.",
  bound_none: "Sem limite",
  payer_both: "Ambos",
  payer_person: "Pessoa física",
  payer_company: "Empresa",
  source_default: "Sem limite configurado",
  source_global_setting: "Limite global",
  source_global: "Herda do global",
  source_org_override: "Override da organização",
  overrides_count: "{{count}} overrides",
  overrides_count_one: "1 override",
  overrides_count_other: "{{count}} overrides",
  overrides_popover_hint: "Toque em uma organização para abrir sua visão e gerenciar o override.",
  action_edit: "Editar",
  action_remove: "Remover limite",
  action_clear_override: "Remover override",
  empty_title: "Nenhum corredor para mostrar",
  empty_description: "Nenhum corredor corresponde ao filtro selecionado.",

  // Edit dialog
  dialog_title: "Limites de {{rail}}",
  dialog_scope_global: "Aplica-se a todas as organizações sem override próprio.",
  dialog_scope_org: "Cria um override apenas para a organização selecionada.",
  dialog_consequence:
    "A partir do momento em que salvar, um valor fora desta faixa é rejeitado na prévia e na criação. O que já está em andamento não é afetado.",
  payer_type_label: "Aplica-se a",
  payer_type_hint:
    "Uma linha por tipo de pagador prevalece sobre a linha «Ambos». No PSE o pagador declara se é pessoa física ou jurídica; nos demais trilhos infere-se do documento.",
  min_label: "Mínimo por operação",
  max_label: "Máximo por operação",
  unbounded_placeholder: "Sem limite",
  reason_label: "Motivo (opcional)",
  reason_placeholder: "Ex.: teto da rede para pessoa física",
  reason_internal_hint:
    "O motivo é de uso interno: somente a equipe da Coloca o vê. O cliente vê a mensagem genérica com o limite.",
  validation_money: "Digite um valor válido.",
  validation_at_least_one: "Informe pelo menos um mínimo ou um máximo.",
  validation_min_below_max: "O mínimo deve ser menor que o máximo.",
  validation_fraction_digits: "{{currency}} permite até {{digits}} decimais.",
  dialog_cancel: "Cancelar",
  dialog_submit: "Salvar limite",

  // Remove dialog
  clear_title: "Remover o limite",
  clear_description: "O corredor ficará sem limite configurado no escopo global.",
  clear_override_description:
    "A organização voltará a herdar os limites globais deste corredor (ou não terá limite).",
  clear_rows_intro: "Estas linhas serão removidas:",
  clear_confirm: "Remover",
  clear_cancel: "Cancelar",

  // Toasts / errors
  toast_saved: "Limite de {{rail}} salvo.",
  toast_cleared: "Limite de {{rail}} removido.",
  error_load: "Não foi possível carregar os limites.",
  error_load_detail: "Verifique sua conexão e tente novamente.",
  error_retry: "Tentar novamente",
  error_save: "Não foi possível salvar a alteração.",
  error_no_write_permission: "Seu usuário não tem permissão de escrita em pagamentos.",
};
